import React from "react";
import * as CONSTANTS from "../../utilities/Constants";
import {
    Input,
    Button,
    ToggleSwitch,
    Dropdown,
    DropdownOption,
    Checkbox,
} from "@abb/abb-common-ux-react";
import { Translation } from "react-i18next";
import { StringNullableChain } from "lodash";

interface IProps {
    autoDeleteSettings: any;
    setAutoDelete: (value: boolean) => void;
    setAutoDeleteFrequency: (value: string) => void;
    setSelectedFrequencyType: (value: string) => void;
    setAutoDeleteTimingInHours: (value: string) => void;
    setAutoDeleteTimingInMinutes: (value: string) => void;
    setAutoDeleteInterval: (value: string) => void;
    setSelectedAutoDeleteInterval: (value: string) => void;
}
interface AppState {
}

export default class AutoDeleteSetting extends React.Component<IProps, AppState> {
    private _mount: boolean = false;
    private hours = Array.from({ length: 24 }, (v, i) => ({ label: i.toString().padStart(2, '0'), value: i }));
    private minutes = Array.from({ length: 60 }, (v, i) => ({ label: i.toString().padStart(2, '0'), value: i }));
    private _autoDeleteTimingInHours: any;
    private _autoDeleteTimingInMinutes: any;
    private _selectedFrequencyType: any = "Days";
    private _selectedAutoDeleteInterval: any = "Days";
    private _frequencies = [
        { label: 'Days', value: 'days' },
        { label: 'Weeks', value: 'weeks' },
        { label: 'Months', value: 'months' },
        { label: 'Years', value: 'years' },
    ];
    constructor(props: IProps) {
        super(props);
        this._mount = true;
        this.state = {
        };
    }

    componentWillUnmount() {
        this._mount = false;
    }

    componentDidMount() {
        this._mount = true;
    }

    public render() {
        console.log(this.props.autoDeleteSettings);
        this._autoDeleteTimingInHours = {
            label: this.props.autoDeleteSettings.autoDeleteTimingInHours,
            value: this.props.autoDeleteSettings.autoDeleteTimingInHours
        };
        this._autoDeleteTimingInMinutes = {
            label: this.props.autoDeleteSettings.autoDeleteTimingInMinutes,
            value: this.props.autoDeleteSettings.autoDeleteTimingInMinutes
        };
        this._selectedFrequencyType = {
            label: this.props.autoDeleteSettings.selectedFrequencyType,
            value: this.props.autoDeleteSettings.selectedFrequencyType
        }
        this._selectedAutoDeleteInterval = {
            label: this.props.autoDeleteSettings.selectedAutoDeleteInterval,
            value: this.props.autoDeleteSettings.selectedAutoDeleteInterval
        }
        return (
            <Translation>
                {(t) => (
                    <div className="page-layout h-100">
                        <div className="summary-layout mt-4">
                            <div className="row">
                                <div className="col-7">
                                    <div className="row">
                                        <label
                                            className="col-5"
                                        >
                                            <b>{t("Auto Delete")}</b>
                                        </label>
                                        <div className="col-7">
                                            <ToggleSwitch
                                                monochrome={true}
                                                showIcons={true}
                                                className="spinner-position"
                                                value={this.props.autoDeleteSettings.isAutoDeleteOn ? true : false}
                                                onChange={(value) =>
                                                    this.props.setAutoDelete(value)
                                                }
                                                style={{ margin: 0 }}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <div className="row mt-3">
                                            <label
                                                className="col-5"
                                            >
                                                <b>{t("Auto Delete Frequency")}</b>
                                            </label>
                                            <div className="col-7 d-flex">
                                                <Input
                                                    dataType="text"
                                                    value={this.props.autoDeleteSettings.frequency}
                                                    onValueChange={(value) =>
                                                        this.props.setAutoDeleteFrequency(value)
                                                    }
                                                    style={{ marginRight: "5%", width: "40%" }}
                                                    disabled={!this.props.autoDeleteSettings.isAutoDeleteOn}
                                                />
                                                <Dropdown
                                                    searchable={false}
                                                    value={this._selectedFrequencyType}
                                                    onChange={(value) => this.props.setSelectedFrequencyType(value[0].label)}
                                                    className="width-40"
                                                    disabled={!this.props.autoDeleteSettings.isAutoDeleteOn}
                                                >
                                                    {this._frequencies?.map((o: any, index: any) => (
                                                        <DropdownOption
                                                            key={index}
                                                            label={o.label}
                                                            value={o.value}
                                                        />
                                                    ))}
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <label
                                                className="col-5"
                                            >
                                                <b>{t("Auto Delete Timing")}</b>
                                            </label>
                                            <div className="col-7 d-flex">
                                                <Dropdown
                                                    searchable={false}
                                                    value={this._autoDeleteTimingInHours}
                                                    onChange={(value) => this.props.setAutoDeleteTimingInHours(value[0].label)}
                                                    className="width-100"
                                                    style={{ marginRight: "5%", width: "5em" }}
                                                    disabled={!this.props.autoDeleteSettings.isAutoDeleteOn}
                                                >
                                                    {this.hours?.map((o: any, index: any) => (
                                                        <DropdownOption
                                                            key={index}
                                                            label={o.label}
                                                            value={o.value}
                                                            disabled={new Date().getHours() > o.value}
                                                        />
                                                    ))}
                                                </Dropdown>

                                                <Dropdown
                                                    searchable={false}
                                                    value={this._autoDeleteTimingInMinutes}
                                                    onChange={(value) => this.props.setAutoDeleteTimingInMinutes(value[0].label)}
                                                    className="width-100"
                                                    style={{ marginRight: "5%", width: "5em" }}
                                                    disabled={!this.props.autoDeleteSettings.isAutoDeleteOn}
                                                >
                                                    {this.minutes?.map((o: any, index: any) => (
                                                        <DropdownOption
                                                            key={index}
                                                            label={o.label}
                                                            value={o.value}
                                                            disabled={this.props.autoDeleteSettings.autoDeleteTimingInHours <= new Date().getHours() && new Date().getMinutes() + 1 > o.value}
                                                        />
                                                    ))}
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <label
                                                className="col-5"
                                            >
                                                <b>{t("Auto Delete Interval")}</b>
                                                <span className="required_header_blue">*</span>
                                            </label>
                                            <div className="col-7 d-flex">
                                                <Input
                                                    dataType="text"
                                                    value={this.props.autoDeleteSettings.autoDeleteInterval}
                                                    onValueChange={(value) =>
                                                        this.props.setAutoDeleteInterval(value)
                                                    }
                                                    style={{ marginRight: "5%", width: "40%" }}
                                                    disabled={!this.props.autoDeleteSettings.isAutoDeleteOn}
                                                />
                                                <Dropdown
                                                    searchable={false}
                                                    value={this._selectedAutoDeleteInterval}
                                                    onChange={(value) => this.props.setSelectedAutoDeleteInterval(value[0].label)}
                                                    className="width-40"
                                                    disabled={!this.props.autoDeleteSettings.isAutoDeleteOn}
                                                >
                                                    {this._frequencies?.map((o: any, index: any) => (
                                                        <DropdownOption
                                                            key={index}
                                                            label={o.label}
                                                            value={o.value}
                                                        />
                                                    ))}
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <label
                                                className="col-5"
                                            >
                                                <b>{t("Last Deleted On")}</b>
                                            </label>
                                            <div className="col-7 d-flex">
                                                <p>
                                                    {this.props.autoDeleteSettings.samplesLastDeletedOn === "" || this.props.autoDeleteSettings.samplesLastDeletedOn === null
                                                        ? "--"
                                                        : new Date(this.props.autoDeleteSettings.samplesLastDeletedOn).toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="row mt-3"><p className="col-12"><b>{t(CONSTANTS.NOTE)}:</b>&nbsp;{t("Samples in measuring state cannot be deleted.")}</p></div>
                                        <div className="row"><p className="col-12"><b>{t(CONSTANTS.NOTE)}:</b>&nbsp;<span className="required_header_blue">*</span>{t("samples older than the auto delete interval will be automatically deleted.")}</p></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Translation>
        );
    }
}
